import { render } from "./ParamBlock.vue?vue&type=template&id=b10885f6&scoped=true&ts=true"
import script from "./ParamBlock.vue?vue&type=script&lang=ts"
export * from "./ParamBlock.vue?vue&type=script&lang=ts"

import "./ParamBlock.vue?vue&type=style&index=0&id=b10885f6&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b10885f6"]])

export default __exports__